<template>
<div>
  <quill-editor
    ref="myQuillEditor"
    v-model="html_content"
    :options="editorOption"
    @focus="onEditorFocus($event)"
    @blur="onEditorBlur($event)"
    @change="onEditorChange($event)"
    class="editor"
  />
  <form action method="post" enctype="multipart/form-data" id="uploadFormMulti">
    <input
      style="display: none"
      :id="uniqueId"
      type="file"
      name="file"
      multiple
      accept="image/jpg, image/jpeg, image/png, image/gif"
      @change="uploadImg('uploadFormMulti')"
    />
  </form>
</div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor,Quill } from "vue-quill-editor";
// 设置title
import { setQuillTitle } from './js/quill-title.js'
import Video from './js/quill-video'



// import Quill from "quill";
import ImageResize from "quill-image-resize-module"; // 引用
import { ImageDrop } from "quill-image-drop-module";
import axios from "axios";
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize); // 注册
Quill.register(Video, true)

// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
  ["blockquote", "code-block"], // 引用  代码块-----['blockquote', 'code-block']
  [{ header: 1 }, { header: 2 }], // 1、2 级标题-----[{ header: 1 }, { header: 2 }]
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
  [{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
  [{ indent: "-1" }, { indent: "+1" }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
  [{ direction: "rtl" }], // 文本方向-----[{'direction': 'rtl'}]
  [{ size: ["small", false, "large", "huge"] }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
  [{ font: [] }], // 字体种类-----[{ font: [] }]
  [{ align: [] }], // 对齐方式-----[{ align: [] }]
  ["clean"], // 清除文本格式-----['clean']
  ["image", "video"], // 链接、图片、视频-----['link', 'image', 'video']
  ['sourceEditor']
];

function postUpload(url=null,file) {
  return axios({
    url: url,
    method: 'post',
    data: file,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export default {
  name: "HtmlEditor",
  components: {
    quillEditor
  },
  props:{
    content:{
      type:String,
      default(){
        return ""
      }
    },
    uploadUrl:{
      type:String,
      default(){
        return ""
      }
    },
    hostUrl:{
      type:String,
      default(){
        return ""
      }
    },
  },
  data() {
    return {
      uniqueId: "uniqueId",
      html_content: "", // 富文本编辑器默认内容
      editorOption: {
        //  富文本编辑器配置
        modules: {
          imageDrop: true,
          imageResize: {
            displayStyles: {
              backgroundColor: "black",
              border: "none",
              color: "white"
            },
            modules: ["Resize", "DisplaySize", "Toolbar"]
          },
          toolbar: toolbarOptions
        },
        theme: "snow",
        placeholder: "请输入正文"
      }
    };
  },
  created() {
    this.html_content=this.content;
  },
  computed: {
    //当前富文本实例
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  methods: {
    // 准备富文本编辑器
    onEditorReady() {},
    // 富文本编辑器 失去焦点事件
    onEditorBlur() {},
    // 富文本编辑器 获得焦点事件
    onEditorFocus() {},
    // 富文本编辑器 内容改变事件
    onEditorChange({ editor, html, text }) {
      this.$emit('onEditor',{ editor, html, text })
    },
    uploadImg: async function() {
      var _this = this;
      //构造formData对象
      var formData = new FormData();
      formData.append("file", document.getElementById(_this.uniqueId).files[0]);
      try {
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        //调用上传文件接口
        postUpload(this.uploadUrl,formData).then(res => {
          console.log(res)
          // 返回上传文件的地址
          let url = res.data.data.path;
          if (url != null && url.length > 0) {
            url=url.replace("\\","/");
            let Range = _this.editor.getSelection();
            url = url.indexOf("http") != -1 ? url : _this.hostUrl + url;
            //上传文件成功之后在富文本中回显(显示)
            _this.editor.insertEmbed(
              Range != null ? Range.index : 0,
              "image",
              url
            );
          } else {
            _this.$message.warning("图片上传失败");
          }
          //成功之后,将文件的文本框的value置空
          document.getElementById(_this.uniqueId).value = "";
        }).catch(e=>{
          console.log(e);
        });
      } catch ({ message: msg }) {
        document.getElementById(_this.uniqueId).value = "";
        _this.$message.warning(msg);
      }
    }
  },
  mounted() {
    var _this = this;
    var imgHandler = async function(image) {
      if (image) {
        var fileInput = document.getElementById(_this.uniqueId); //隐藏的file文本ID
        fileInput.click(); //加一个触发事件
      }
    };
    setQuillTitle();
    _this.editor.getModule("toolbar").addHandler("image", imgHandler);
  },
  watch:{
    content(n){
      this.html_content=n;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Cms/components/HtmlEditor.vue